import React from "react";
import { ChevronRight } from "lucide-react";
import BackgroundWrapper from "../components/BackgroundWrapper";

import { Link } from "react-router-dom";

export default function OrgChange() {
  return (
    <BackgroundWrapper>
      
      <div className="pt-8 pb-20 px-4 min-h-screen">
        <div className="max-w-5xl mx-auto">
          <Link
            to="/programs"
            className="mb-8 inline-flex items-center text-blue-600 hover:text-blue-700 font-semibold"
          >
            ← Back to Programs
          </Link>

          <div className="bg-white/90 backdrop-blur-md rounded-3xl shadow-2xl p-8 md:p-12">
            <h1 className="sm:text-2xl text-1xl font-bold text-slate-800 mb-8">
              Organizational Change & Development Management
            </h1>

            <h3 className="sm:text-3xl text-xl font-bold text-slate-800 mb-4">
              Suitable for:
            </h3>
            <ul className="list-disc list-inside text-slate-700 mb-6 space-y-1 sm:text-lg text-sm">
              <li>New organization implementation</li>
              <li>Transformation and change programs</li>
              <li>Employee engagement enhancement</li>
              <li>Organizational performance improvement</li>
            </ul>

            <h3 className="sm:text-3xl text-xl font-bold text-slate-800 mb-4">
              Our Approach:
            </h3>
            <p className="text-slate-700 mb-4 sm:text-lg text-sm">
              Following the introduction of a new strategy, we support
              organizations to adapt to the change through:
            </p>
            <ul className="list-disc list-inside text-slate-700 mb-6 space-y-1 sm:text-lg text-sm">
              <li>Organizational effectiveness improvement</li>
              <li>Group behavior and culture change</li>
              <li>Improving success factors for new operating models</li>
            </ul>

            <div className="bg-indigo-50 rounded-2xl p-6 mb-8">
              <h3 className="text-xl font-bold text-slate-800 mb-3">
                Tools & Methods:
              </h3>
              <p className="text-slate-700 sm:text-lg text-sm">
                We employ surveys, interviews, workshops and coaching to assess
                and modify company culture, values and behaviors.
              </p>
            </div>

            <div className="bg-blue-100 rounded-2xl p-6 mb-8">
              <p className="text-sm font-semibold text-blue-800">
                Internationally accredited and regulated.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <Link
                to="/contact"
                className="bg-gradient-to-r from-indigo-600 to-purple-600 text-white px-8 py-4 rounded-full font-semibold hover:shadow-2xl transition-all text-center"
              >
                Contact Us <ChevronRight className="inline ml-2" />
              </Link>
              <Link
                to="/programs"
                className="bg-white border-2 border-indigo-600 text-indigo-600 px-8 py-4 rounded-full font-semibold hover:shadow-xl transition-all text-center"
              >
                View All Programs
              </Link>
            </div>
          </div>
        </div>
      </div>
    </BackgroundWrapper>
  );
}